import React from "react";
import "./HomeSec2.css";

const HomeSec2 = () => {
  return (
    <div className="stats-container">
      
      <div className="stat-card">
        <h2>500+</h2>
        <p>Exhibitors</p>
      </div>

      <div className="stat-card">
        <h2>20k</h2>
        <p>Attendees</p>
      </div>

      <div className="stat-card">
        <h2>4</h2>
        <p>Halls</p>
      </div>

    </div>
  );
};

export default HomeSec2;